import Resource from 'Resources/ResourceTyped';
import { TierUpgradeRequest } from './Model/TierUpgradeRequest';

type TierUpgradeRequestSave = Partial<TierUpgradeRequest>;

class TierUpgradeRequestResource extends Resource<TierUpgradeRequest, TierUpgradeRequest, TierUpgradeRequestSave> {
	constructor() {
		super('tierUpgradeRequests');
	}
}

const resource = new TierUpgradeRequestResource();
export default resource;
